import * as Yup from 'yup'
import dayjs, { Dayjs } from 'dayjs';
import { _roleType } from '@custom/Utils/constants/appConstants';

export const phoneNumberRegex = /^\d{10}$/;
export const dateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d\d$/;

export const EMAIL = {
  label: "Email",
  validation: {
    required: "Email is required",
    valid: "Please enter a valid email address.",
  },
};

export const CONTACT_NUMBER = {
  label: "Contact number",
  validation: {
    valid: "Please enter a valid 10-digit contact number.",
    required:"Contact number is required"
  },
};

export const Name = {
  label: "Name",
  validation: {
    valid: "Name is required",
    required:"Name is required"
  },
};

export const Role = {
  label: "Role",
  validation: {
    valid: "Role is required",
    required: "Role is required"
  },
};

export const DOB = {
  label: "Date of Birth",
  validation: {
    valid: "Date format must be DD/MM/YYYY",
    required: "Date Of Birth is required"
  },
  regex: dateRegex,
};

export const LICENSE_NUMBER = {
  label: "LICENSE NUMBER",
  validation: {
    valid: "License number is required",
    required: "License number is required"
  },
};

export const EmployeeId = {
  label: "Employee Id",
  validation: {
    valid: "Employee Id is required",
    required:"Employee Id is required"
  },
}

export const UserFormSchema=Yup.object().shape({
  name:Yup.string(),
  employeeId:Yup.string(),
  userRole:Yup.string(),
  hprid:Yup.string(),
  gender: Yup.string(),
  emailId: Yup.string().email(EMAIL.validation.valid).required(EMAIL.validation.required),
  contactNumber:Yup.string().matches(phoneNumberRegex),
  dob: Yup.date(),
  department:Yup.string(),
  specialization:Yup.string(),
  yearsOfExperience:Yup.string(),
  whatsappNumber: Yup.string().matches(phoneNumberRegex),
  licenseNumber: Yup.string(),
})

export const getValidationSchema = (role) => {
  const schemaFields = {
    name: Yup.string().required(Name.validation.required),
    employeeId: Yup.string(),
    role: Yup.string().required(Role.validation.required),
    hprid: Yup.string(),
    gender: Yup.string(),
    email: Yup.string().email().required(EMAIL.validation.required).test('no-uppercase', EMAIL.validation.invalidCaps, value => {
      return !value || value === value.toLowerCase();
    }),
    contactNumber: Yup.string()
      .required('Contact number is required')
      .matches(/^[0-9]{10}$/, 'Please enter a valid 10-digit contact number'),
    dob: role === _roleType.hospitalSuperadmin ? '' : role === _roleType.government ? Yup.date() : Yup.date().required(DOB.validation.required).nullable()
      .test('isValid', 'Date of birth is required', (value) => value && dayjs(value).isValid()),
    department: Yup.string(),
    specialization: Yup.array(),
    yearsOfExperience: Yup.string(),
    whatsappNumber: Yup.string().matches(phoneNumberRegex, CONTACT_NUMBER.validation.valid),
    sameAsContact: Yup.boolean(),
    licenseNumber: role === _roleType.admin || role === _roleType.frontDesk || role === _roleType.technician || role === _roleType.government || role === _roleType.hospitalSuperadmin ? Yup.string() : Yup.string().required(LICENSE_NUMBER.validation.required),
     technicianDepartment: role === _roleType.technician ? Yup.string().required('Technician department is required').oneOf(['Radiology', 'Pathology'], 'Please select a valid technician department') : Yup.string()
    
  }
  if (role === _roleType.frontDesk) {
    schemaFields.aprroveDiscount = Yup.boolean().default(false);
  }

  return Yup.object().shape(schemaFields);
}
